// utils/affiliations.js
const getAffiliatedStudents = (scholarship, students) => {
  if (!Array.isArray(students) || !scholarship?.id) {
    return { matchingStudents: [], affiliationName: "" };
  }

  let affiliationName = "";

  const matchingStudents = students
    .map((student) => {
      if (!student.affiliations) return null;

      const affiliationEntries = student.affiliations
        .split("||")
        .map((entry) => {
          const [id, name, rejectedRaw, moreInfoValue, moreInfoText] = entry
            .split("::")
            .map((s) => s.trim());
          return {
            id,
            name,
            moreInfoValue,
            moreInfoText,
            rejected: rejectedRaw === "true" || rejectedRaw === "1", // normalize
          };
        });

      const match = affiliationEntries.find(
        (a) => a.id === scholarship.id.toString()
      );

      if (match) {
        if (!affiliationName) {
          affiliationName = match.name;
        }

        return {
          ...student,
          moreInfoText: match.moreInfoText,
          moreInfoValue: match.moreInfoValue,
          rejected: match.rejected, // Inject the correct affiliation-specific rejection flag
        };
      }

      return null;
    })
    .filter(Boolean); // Remove nulls

  return { matchingStudents, affiliationName };
};

export default getAffiliatedStudents;
